module.exports = __webpack_public_path__ + "img/share-tip.3ab86c7d.png";